import { QueryClient } from '@tanstack/react-query';
import { loadAuthUser } from '~/shared/auth/auth-utils';

export const rootLoader = (queryClient: QueryClient) => async () => {
  await loadAuthUser(queryClient);
  return null;
};
